import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axiosInstance from '../../../redux/api';
import LegalEditor from './LegalEditor';

const PAGES = { terms: 'Terms and Conditions', privacy: 'Privacy Policy', service: 'Service Agreement / Service Usage' };

export default function LegalDocuments() {
  const { slug = 'terms' } = useParams();
  const [document, setDocument] = useState(null);
  const [busy, setBusy] = useState(false);
  const [dirty, setDirty] = useState(false);
  const [message, setMessage] = useState('');
  useEffect(() => {
    let active = true;
    setDocument(null); setBusy(true); setMessage('');
    axiosInstance.get(`cms/legal/${slug}`).then(({ data }) => {
      if (!active) return;
      if (!data.status) throw new Error(data.message || 'Unable to load document');
      setDocument({ ...data.response, editor_body: data.response.editor_html }); setDirty(false);
    }).catch(error => { if (active) setMessage(error.message); })
      .finally(() => { if (active) setBusy(false); });
    return () => { active = false; };
  }, [slug]);
  useEffect(() => {
    const warn = event => { if (dirty) { event.preventDefault(); event.returnValue = ''; } };
    window.addEventListener('beforeunload', warn);
    return () => window.removeEventListener('beforeunload', warn);
  }, [dirty]);
  const edit = (language, value) => {
    setDocument(current => ({ ...current, editor_body: { ...current.editor_body, [language]: value } }));
    setDirty(true); setMessage('');
  };
  const save = async event => {
    event.preventDefault(); setBusy(true); setMessage('');
    try {
      const { data } = await axiosInstance.post(`cms/legal/${slug}`, { revision: document.revision, body: document.editor_body, body_format: 'html' });
      if (!data.status) throw new Error(data.message || 'Unable to save document');
      setDocument({ ...data.response, editor_body: data.response.editor_html }); setDirty(false); setMessage('Saved. The public page now uses these changes.');
    } catch (error) { setMessage(error.message); }
    finally { setBusy(false); }
  };
  return <div className="p-3 category-wrapper">
    <h3>{PAGES[slug] || 'Legal Page'}</h3>
    <p>Edit the complete English and Arabic documents with formatting or HTML. Preview before saving. Save publishes the corresponding website page.</p>
    {message && <p role="status">{message}</p>}
    {busy && !document && <p role="status">Loading…</p>}
    {document && <form onSubmit={save}>
      <fieldset disabled={busy}>
        <div className="row mb-4">
          {['en', 'ar'].map(language => <div className="col-md-6" key={language}>
            <LegalEditor language={language} value={document.editor_body[language]} disabled={busy}
              onChange={value => edit(language, value)} />
          </div>)}
        </div>
        <button className="btn btn-primary" type="submit" disabled={!dirty}>{busy ? 'Saving…' : 'Save changes'}</button>
      </fieldset>
    </form>}
  </div>;
}
